var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "expanded-wrapper" },
    [
      _c("BetslipBody", {
        attrs: {
          bettingLocked: _vm.bettingLocked,
          theme: _vm.theme,
          payinDisabled: _vm.disabled,
          predefinedStakes: _vm.predefinedStakes,
          bettingDisabled: _vm.bettingDisabled,
        },
      }),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c("BetslipFooter", {
            attrs: {
              bettingLocked: _vm.bettingLocked,
              payinDisabled: _vm.disabled,
              predefinedStakes: _vm.predefinedStakes,
              bettingDisabled: _vm.bettingDisabled,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }